export default __webpack_public_path__ + "src/assets/images/default_plug.png?e683f30d";